import React from 'react'
import { CircularProgress } from '@material-ui/core'

const LoadingIcon = () => (
  <CircularProgress
    style={{ color: '#289c91', width: '32px', height: '32px', marginLeft: '30px' }}
  />
)

export default LoadingIcon
